import React, { useState } from "react";
import { Button, Form, ProgressBar } from "react-bootstrap";
import { useSelector } from "react-redux";
import { getLoading } from "../../../controller/reducer/ui";
import { login } from "../../../controller/reducer/user";
import Header from "../common/header";
import "./styles.css";

const LoginPage = ({ dispatch }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  // const [remember, setRemember] = useState(false);

  const submitTask = (e) => {
    e.preventDefault();
    const payload = {
      data: { email, password },
      remember: true,
    };
    dispatch(login(payload));
  };

  const loading = useSelector(getLoading);

  return (
    <div className="">
      <Header />
      <Form onSubmit={submitTask} className="p-4">
        <h1>Login</h1>
        {loading && <ProgressBar animated variant="secondary" now={100} />}
        <hr className="hr-light" />
        <Form.Group>
          <Form.Label>Email address</Form.Label>
          <Form.Control
            type="email"
            placeholder="Enter email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </Form.Group>
        <Form.Group>
          <Form.Label>Password</Form.Label>
          <Form.Control
            type="password"
            placeholder="Password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </Form.Group>
        {/* <Form.Group>
          <Form.Check
            type="checkbox"
            label="Remember Me"
            checked={remember}
            onChange={() => setRemember(!remember)}
          />
        </Form.Group> */}
        <Button variant="primary" type="submit" block>
          Sign In
        </Button>
      </Form>
    </div>
  );
};

export default LoginPage;
